const translations = {
    ac: 'Ac',
    addChemical: 'Add Chemical',
    carrier: 'Carrier',
    errors: {
        rateAppliedGreaterThanZero: 'Rate Must Be Greater Than Or Equal To 0',
        rateAppliedTooLarge: 'Rate Must Be Less Than {{rate}} {{unit}}',
        totalAcresGreaterThanZero: 'Total Acres Applied Must Be Greater Than Or Equal To 0',
        volumeAppliedGreaterThanZero: 'Amount Applied Must Be Greater Than Or Equal to 0',
        volumeAppliedTooLarge: 'Amount Must Be Less Than {{maxVolumeApplied}} {{unit}}'
    },
    fluidOuncesPerAcreUnit: 'Fl. Oz/Ac',
    gallons: 'Gallons',
    gallonsPerAcreUnit: 'Ga/Ac',
    liters: 'Liters',
    litersPerHectareUnit: 'L/Ha',
    litersPerMeterSquaredUnit: 'L/m\u00b2',
    rateApplied: 'Rate Applied',
    totalAcresApplied: 'Total Acres Applied',
    totalProductUsed: 'Total Product Used'
};

export default translations;
